import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-study-helper',
  templateUrl: './study-helper.component.html',
  styleUrls: ['./study-helper.component.css']
})
export class StudyHelperComponent implements OnInit {

  pageContent8 = [
    {
      title: 'CONAPE',
      topic: 'Consejo Nacional de Préstamos para Educación (CONAPE)',
      link: 'http://www.conape.go.cr/informacion-general/#quefinanciamos'
    }
  ];

  pageContent9 = [
    {
      title: 'Universia - Página para trabajar en españa',
      topic: 'Universia (Iberoamérica, mecenazgo Santander)',
      link: 'http://becas.universia.net'
    },
    {
      title: 'Tiene convenio con la Estatal a Distancia y con la UCR',
      topic: 'Becas Asociación Universitaria Iberoamericana de Posgrado (AUIP)',
      link: 'http://www.auip.org/es/becasauip'
    },
    {
      title: 'Becas para latinos (México)',
      topic: 'Fundación Beca',
      link: 'https://www.fundacionbeca.net'
    },
    {
      title: '',
      topic: 'Solicitud del visado de estudiante: requisitos para estudiar en España siendo extracomunitario',
      link: 'https://www.reclamador.es/blog/visa-estudiante-espana-requisitos-documentacion/'
    },
    {
      title: '',
      topic: 'Servicio español para la internacionalización de la educación (SEPIE)',
      link: 'http://sepie.es/internacionalizacion/programas.html'
    },
    {
      title: '',
      topic: 'Becas Santander',
      link: 'http://www.becas-santander.com'
    },
    {
      title: '',
      topic: 'Fundación Carolina',
      link: 'https://www.fundacioncarolina.es'
    },
    {
      title: '',
      topic: 'Becas La Caixa',
      link: 'https://obrasociallacaixa.org/es/educacion-becas'
    },
    {
      title: '',
      topic: 'Solicitud del visado de estudiante: requisitos para estudiar en España siendo extracomunitario',
      link: 'https://www.reclamador.es/blog/visa-estudiante-espana-requisitos-documentacion/'
    },
    {
      title: '',
      topic: 'Guía práctica para obtener la Visa de Estudiante en España 2019',
      link: 'https://deaboga.com/visa-estudiante-espana/'
    },
    {
      title: '',
      topic: 'Como obtener la visa de estudiante',
      link: 'https://blogs.imf-formacion.com/blog/corporativo/consejos-2/estudiar-espana-obtener-visa-estudiante/'
    },
    {
      title: '',
      topic: 'BECAS COSTA RICA',
      link: 'https://universidades.cr/becas'
    },
  ];
  
  constructor() { }

  ngOnInit(): void {
  }

}
